import { ValidationMessage } from '@sdbn/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

@Component({
  selector: 'app-show-message',
  templateUrl: './show-message.component.html',
  styleUrls: ['./show-message.component.scss']
})
export class ShowMessageComponent extends AbstractWidgetComponent implements OnInit {

  validationMessages = new Array<ValidationMessage>();

  constructor(
    public translationService: TranslationService
  ) {
    super();
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'validationMessages') {
      this.validationMessages = contextChange.value;
    }
  }

  onSetElementAndContext() {
    this.validationMessages = this.dashboardContext.getContextValue('validationMessages');
  }


  ngOnInit(): void {

  }



}
